import D from "react";
var W = {}, fr = {
  get exports() {
    return W;
  },
  set exports(a) {
    W = a;
  }
}, $ = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ce;
function vr() {
  if (Ce)
    return $;
  Ce = 1;
  var a = D, l = Symbol.for("react.element"), g = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, P = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(h, f, R) {
    var p, y = {}, C = null, S = null;
    R !== void 0 && (C = "" + R), f.key !== void 0 && (C = "" + f.key), f.ref !== void 0 && (S = f.ref);
    for (p in f)
      s.call(f, p) && !T.hasOwnProperty(p) && (y[p] = f[p]);
    if (h && h.defaultProps)
      for (p in f = h.defaultProps, f)
        y[p] === void 0 && (y[p] = f[p]);
    return { $$typeof: l, type: h, key: C, ref: S, props: y, _owner: P.current };
  }
  return $.Fragment = g, $.jsx = _, $.jsxs = _, $;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xe;
function dr() {
  return xe || (xe = 1, process.env.NODE_ENV !== "production" && function() {
    var a = D, l = Symbol.for("react.element"), g = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), P = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), h = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), A = Symbol.iterator, je = "@@iterator";
    function ke(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = A && e[A] || e[je];
      return typeof r == "function" ? r : null;
    }
    var j = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        Fe("error", e, t);
      }
    }
    function Fe(e, r, t) {
      {
        var n = j.ReactDebugCurrentFrame, u = n.getStackAddendum();
        u !== "" && (r += "%s", t = t.concat([u]));
        var c = t.map(function(i) {
          return String(i);
        });
        c.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var De = !1, Ae = !1, Me = !1, Ie = !1, $e = !1, re;
    re = Symbol.for("react.module.reference");
    function Ye(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === s || e === T || $e || e === P || e === R || e === p || Ie || e === S || De || Ae || Me || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === y || e.$$typeof === _ || e.$$typeof === h || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function We(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var u = r.displayName || r.name || "";
      return u !== "" ? t + "(" + u + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function x(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case s:
          return "Fragment";
        case g:
          return "Portal";
        case T:
          return "Profiler";
        case P:
          return "StrictMode";
        case R:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            var r = e;
            return te(r) + ".Consumer";
          case _:
            var t = e;
            return te(t._context) + ".Provider";
          case f:
            return We(e, e.render, "ForwardRef");
          case y:
            var n = e.displayName || null;
            return n !== null ? n : x(e.type) || "Memo";
          case C: {
            var u = e, c = u._payload, i = u._init;
            try {
              return x(i(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var w = Object.assign, M = 0, ne, ae, oe, ie, ue, se, ce;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function Ne() {
      {
        if (M === 0) {
          ne = console.log, ae = console.info, oe = console.warn, ie = console.error, ue = console.group, se = console.groupCollapsed, ce = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        M++;
      }
    }
    function Le() {
      {
        if (M--, M === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: w({}, e, {
              value: ne
            }),
            info: w({}, e, {
              value: ae
            }),
            warn: w({}, e, {
              value: oe
            }),
            error: w({}, e, {
              value: ie
            }),
            group: w({}, e, {
              value: ue
            }),
            groupCollapsed: w({}, e, {
              value: se
            }),
            groupEnd: w({}, e, {
              value: ce
            })
          });
        }
        M < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = j.ReactCurrentDispatcher, G;
    function N(e, r, t) {
      {
        if (G === void 0)
          try {
            throw Error();
          } catch (u) {
            var n = u.stack.trim().match(/\n( *(at )?)/);
            G = n && n[1] || "";
          }
        return `
` + G + e;
      }
    }
    var J = !1, L;
    {
      var Ue = typeof WeakMap == "function" ? WeakMap : Map;
      L = new Ue();
    }
    function fe(e, r) {
      if (!e || J)
        return "";
      {
        var t = L.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      J = !0;
      var u = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = q.current, q.current = null, Ne();
      try {
        if (r) {
          var i = function() {
            throw Error();
          };
          if (Object.defineProperty(i.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(i, []);
            } catch (O) {
              n = O;
            }
            Reflect.construct(e, [], i);
          } else {
            try {
              i.call();
            } catch (O) {
              n = O;
            }
            e.call(i.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            n = O;
          }
          e();
        }
      } catch (O) {
        if (O && n && typeof O.stack == "string") {
          for (var o = O.stack.split(`
`), m = n.stack.split(`
`), v = o.length - 1, d = m.length - 1; v >= 1 && d >= 0 && o[v] !== m[d]; )
            d--;
          for (; v >= 1 && d >= 0; v--, d--)
            if (o[v] !== m[d]) {
              if (v !== 1 || d !== 1)
                do
                  if (v--, d--, d < 0 || o[v] !== m[d]) {
                    var E = `
` + o[v].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && L.set(e, E), E;
                  }
                while (v >= 1 && d >= 0);
              break;
            }
        }
      } finally {
        J = !1, q.current = c, Le(), Error.prepareStackTrace = u;
      }
      var F = e ? e.displayName || e.name : "", Te = F ? N(F) : "";
      return typeof e == "function" && L.set(e, Te), Te;
    }
    function Ve(e, r, t) {
      return fe(e, !1);
    }
    function Be(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function U(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return fe(e, Be(e));
      if (typeof e == "string")
        return N(e);
      switch (e) {
        case R:
          return N("Suspense");
        case p:
          return N("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Ve(e.render);
          case y:
            return U(e.type, r, t);
          case C: {
            var n = e, u = n._payload, c = n._init;
            try {
              return U(c(u), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var V = Object.prototype.hasOwnProperty, ve = {}, de = j.ReactDebugCurrentFrame;
    function B(e) {
      if (e) {
        var r = e._owner, t = U(e.type, e._source, r ? r.type : null);
        de.setExtraStackFrame(t);
      } else
        de.setExtraStackFrame(null);
    }
    function qe(e, r, t, n, u) {
      {
        var c = Function.call.bind(V);
        for (var i in e)
          if (c(e, i)) {
            var o = void 0;
            try {
              if (typeof e[i] != "function") {
                var m = Error((n || "React class") + ": " + t + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw m.name = "Invariant Violation", m;
              }
              o = e[i](r, i, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (v) {
              o = v;
            }
            o && !(o instanceof Error) && (B(u), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, i, typeof o), B(null)), o instanceof Error && !(o.message in ve) && (ve[o.message] = !0, B(u), b("Failed %s type: %s", t, o.message), B(null));
          }
      }
    }
    var Ge = Array.isArray;
    function X(e) {
      return Ge(e);
    }
    function Je(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Xe(e) {
      try {
        return ge(e), !1;
      } catch {
        return !0;
      }
    }
    function ge(e) {
      return "" + e;
    }
    function pe(e) {
      if (Xe(e))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Je(e)), ge(e);
    }
    var I = j.ReactCurrentOwner, ze = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, be, z;
    z = {};
    function He(e) {
      if (V.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Ke(e) {
      if (V.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, r) {
      if (typeof e.ref == "string" && I.current && r && I.current.stateNode !== r) {
        var t = x(I.current.type);
        z[t] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', x(I.current.type), e.ref), z[t] = !0);
      }
    }
    function Qe(e, r) {
      {
        var t = function() {
          he || (he = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function er(e, r) {
      {
        var t = function() {
          be || (be = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var rr = function(e, r, t, n, u, c, i) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: l,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: i,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: u
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function tr(e, r, t, n, u) {
      {
        var c, i = {}, o = null, m = null;
        t !== void 0 && (pe(t), o = "" + t), Ke(r) && (pe(r.key), o = "" + r.key), He(r) && (m = r.ref, Ze(r, u));
        for (c in r)
          V.call(r, c) && !ze.hasOwnProperty(c) && (i[c] = r[c]);
        if (e && e.defaultProps) {
          var v = e.defaultProps;
          for (c in v)
            i[c] === void 0 && (i[c] = v[c]);
        }
        if (o || m) {
          var d = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && Qe(i, d), m && er(i, d);
        }
        return rr(e, o, m, u, n, I.current, i);
      }
    }
    var H = j.ReactCurrentOwner, me = j.ReactDebugCurrentFrame;
    function k(e) {
      if (e) {
        var r = e._owner, t = U(e.type, e._source, r ? r.type : null);
        me.setExtraStackFrame(t);
      } else
        me.setExtraStackFrame(null);
    }
    var K;
    K = !1;
    function Z(e) {
      return typeof e == "object" && e !== null && e.$$typeof === l;
    }
    function ye() {
      {
        if (H.current) {
          var e = x(H.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function nr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var _e = {};
    function ar(e) {
      {
        var r = ye();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Ee(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ar(r);
        if (_e[t])
          return;
        _e[t] = !0;
        var n = "";
        e && e._owner && e._owner !== H.current && (n = " It was passed a child from " + x(e._owner.type) + "."), k(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), k(null);
      }
    }
    function Re(e, r) {
      {
        if (typeof e != "object")
          return;
        if (X(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            Z(n) && Ee(n, r);
          }
        else if (Z(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var u = ke(e);
          if (typeof u == "function" && u !== e.entries)
            for (var c = u.call(e), i; !(i = c.next()).done; )
              Z(i.value) && Ee(i.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === y))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = x(r);
          qe(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !K) {
          K = !0;
          var u = x(r);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", u || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            k(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), k(null);
            break;
          }
        }
        e.ref !== null && (k(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), k(null));
      }
    }
    function Pe(e, r, t, n, u, c) {
      {
        var i = Ye(e);
        if (!i) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var m = nr(u);
          m ? o += m : o += ye();
          var v;
          e === null ? v = "null" : X(e) ? v = "array" : e !== void 0 && e.$$typeof === l ? (v = "<" + (x(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : v = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", v, o);
        }
        var d = tr(e, r, t, u, c);
        if (d == null)
          return d;
        if (i) {
          var E = r.children;
          if (E !== void 0)
            if (n)
              if (X(E)) {
                for (var F = 0; F < E.length; F++)
                  Re(E[F], e);
                Object.freeze && Object.freeze(E);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Re(E, e);
        }
        return e === s ? ir(d) : or(d), d;
      }
    }
    function ur(e, r, t) {
      return Pe(e, r, t, !0);
    }
    function sr(e, r, t) {
      return Pe(e, r, t, !1);
    }
    var cr = sr, lr = ur;
    Y.Fragment = s, Y.jsx = cr, Y.jsxs = lr;
  }()), Y;
}
(function(a) {
  process.env.NODE_ENV === "production" ? a.exports = vr() : a.exports = dr();
})(fr);
function we(a) {
  var l, g, s = "";
  if (typeof a == "string" || typeof a == "number")
    s += a;
  else if (typeof a == "object")
    if (Array.isArray(a))
      for (l = 0; l < a.length; l++)
        a[l] && (g = we(a[l])) && (s && (s += " "), s += g);
    else
      for (l in a)
        a[l] && (s && (s += " "), s += l);
  return s;
}
function Q() {
  for (var a, l, g = 0, s = ""; g < arguments.length; )
    (a = arguments[g++]) && (l = we(a)) && (s && (s += " "), s += l);
  return s;
}
const Oe = (a, l) => Math.min(Math.max(a * 100 / l, 0), 100), gr = (a) => (l) => {
  if (a.canMove) {
    const g = l, s = a.container.getBoundingClientRect(), P = g.clientX - s.left, T = g.clientY - s.top, _ = g.currentTarget, h = Oe(P, _.clientWidth), f = Oe(T, _.clientHeight);
    a.setX(h), a.setY(f), a.onChange(h, f);
  }
}, Se = 50, pr = (a) => {
  var f, R;
  const l = D.useRef(null), [g, s] = D.useState(((f = a.focalPoint) == null ? void 0 : f.x) ?? Se), [P, T] = D.useState(((R = a.focalPoint) == null ? void 0 : R.y) ?? Se), [_, h] = D.useState(!1);
  return {
    ref: l,
    x: g,
    y: P,
    onMove: gr({
      setX: s,
      setY: T,
      container: l.current,
      onChange: (p, y) => a.onChange({ x: p, y }),
      canMove: _
    }),
    canMove: _,
    setCanMove: h
  };
}, hr = "_root_1hc8k_1", br = "_focalPoint_1hc8k_8", mr = "_image_1hc8k_19", ee = {
  root: hr,
  focalPoint: br,
  image: mr
}, yr = {
  focalPoint: "Focal point"
}, Er = (a) => {
  var C, S, A;
  const { src: l, onChange: g, alt: s, focalPoint: P } = a, T = { ...yr, ...a.labels || {} }, { ref: _, x: h, y: f, onMove: R, canMove: p, setCanMove: y } = pr({ focalPoint: P, onChange: g });
  return /* @__PURE__ */ W.jsxs("div", { ref: _, className: Q(ee.root, a.className, (C = a.classes) == null ? void 0 : C.root), onMouseMove: R, children: [
    /* @__PURE__ */ W.jsx(
      "button",
      {
        type: "button",
        "aria-label": T.focalPoint,
        style: { left: `${h}%`, top: `${f}%`, cursor: p ? "grabbing" : "grab" },
        className: Q(ee.focalPoint, (S = a == null ? void 0 : a.classes) == null ? void 0 : S.focalPoint),
        onMouseDown: () => y(!0),
        onMouseUp: () => y(!1)
      }
    ),
    /* @__PURE__ */ W.jsx(
      "img",
      {
        style: {
          objectPosition: `${h}% ${f}%`
        },
        className: Q(ee.image, (A = a.classes) == null ? void 0 : A.image),
        src: l,
        alt: s
      }
    )
  ] });
};
export {
  Er as ImageFocalPoint
};
